import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import AuthorizedRoute from 'routes/AuthorizedRoute';

import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';

import { URL as DASHBOARD_URL } from 'pages/dashboard/helper';

import SocialHome from './SocialHome';
import { URL, COMPONENT, SOCIAL_RESOURCES, GET_ACTION } from './helper';

const SocialInfo: React.FC<{}> = () => {
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					configPageName={PAGE_NAMES.dashboard}
					path={DASHBOARD_URL[DASHBOARD_RESOURCES.social]}
					component={SocialHome}
				/>
				{_map(_values(SOCIAL_RESOURCES), (subEntity: string) => (
					<AuthorizedRoute
						key={subEntity}
						configPageName={PAGE_NAMES.dashboard}
						entity={DASHBOARD_RESOURCES.social}
						actions={[GET_ACTION[subEntity]]}
						path={URL[subEntity]}
						component={COMPONENT[subEntity]}
					/>
				))}
				<Redirect to={DASHBOARD_URL[DASHBOARD_RESOURCES.social]} />
			</Switch>
		</>
	);
};

export default SocialInfo;
